import React from "react";
import {
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Divider,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const GsmRangeActionMenu = ({
  onSave,
  onClear,
  onExit,
  isUpdateMode = false,
  saveDisabled = false
}) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      padding={1}
    >
      {/* Title left side */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{ marginLeft: "10px", fontSize: "1.2rem", fontWeight: 600 }}
        >
          {isUpdateMode ? "Edit GSM Range" : "Add New GSM Range"}
        </Typography>
      </Grid>

      {/* Action Buttons Right */}
      <Grid item>
        <Grid container alignItems="center">

          {/* Save */}
          <Grid item sx={{ mx: 1 }}>
            <Tooltip title="Save GSM Range">
              <IconButton
                onClick={onSave}
                disabled={saveDisabled}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <SaveAltIcon sx={{ fontSize: 20, color: "#009688" }} />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  {isUpdateMode ? "Update" : "Save"}
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Clear */}
          {/* <Grid item sx={{ mx: 1 }}>
            <Tooltip title="Clear GSM Form">
              <IconButton
                onClick={onClear}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ClearAllIcon sx={{ fontSize: 20, color: "#e0d620" }} />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid> */}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Exit */}
          <Tooltip title="Exit">
            <IconButton onClick={onExit}>
              <CloseIcon sx={{ fontSize: 18, color: "#2196F3" }} />
            </IconButton>
          </Tooltip>

          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GsmRangeActionMenu;
